/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { SmartDineResponseKitchenOrderModel } from '../model/smartDineResponseKitchenOrderModel';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class KitchenOrderRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param statusList 
     * @param fromDate 
     * @param toDate 
     * @param locale 
     * @param pageNo 
     * @param rows 
     * @param sortByFields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrdersForKitchenDisplay(restaurantId?: string, restaurantBranchId?: string, statusList?: Array<string>, fromDate?: Date, toDate?: Date, locale?: string, pageNo?: number, rows?: number, sortByFields?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseKitchenOrderModel>;
    public getOrdersForKitchenDisplay(restaurantId?: string, restaurantBranchId?: string, statusList?: Array<string>, fromDate?: Date, toDate?: Date, locale?: string, pageNo?: number, rows?: number, sortByFields?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseKitchenOrderModel>>;
    public getOrdersForKitchenDisplay(restaurantId?: string, restaurantBranchId?: string, statusList?: Array<string>, fromDate?: Date, toDate?: Date, locale?: string, pageNo?: number, rows?: number, sortByFields?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseKitchenOrderModel>>;
    public getOrdersForKitchenDisplay(restaurantId?: string, restaurantBranchId?: string, statusList?: Array<string>, fromDate?: Date, toDate?: Date, locale?: string, pageNo?: number, rows?: number, sortByFields?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (statusList) {
            statusList.forEach((element) => {
                queryParameters = queryParameters.append('statusList', <any>element);
            })
        }
        if (fromDate !== undefined && fromDate !== null) {
            queryParameters = queryParameters.set('fromDate', <any>fromDate.toISOString());
        }
        if (toDate !== undefined && toDate !== null) {
            queryParameters = queryParameters.set('toDate', <any>toDate.toISOString());
        }
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }
        if (pageNo !== undefined && pageNo !== null) {
            queryParameters = queryParameters.set('pageNo', <any>pageNo);
        }
        if (rows !== undefined && rows !== null) {
            queryParameters = queryParameters.set('rows', <any>rows);
        }
        if (sortByFields) {
            sortByFields.forEach((element) => {
                queryParameters = queryParameters.append('sortByFields', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseKitchenOrderModel>('get',`${this.basePath}/api/admin/kitchen/orders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
